/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Cell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { WorkplanItem } from '@/wpt-lib/interfaces/WorkplanItem';
import { progressUpdateStatus } from '@/wpt-lib/interfaces/ProgressUpdate';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';

const ProgressUpdates = ({
    item,
    header = true,
    spacer = false,
}: {
    item: WorkplanItem;
    header?: boolean;
    spacer?: boolean;
}) => {
    const updates = item.progressUpdates.sort(
        (u1, u2) => new Date(u1.createdAt).getTime() - new Date(u2.createdAt).getTime(),
    );

    return updates.length > 0 ? (
        <>
            {header && (
                <Row>
                    <SubHeading level={2} text="Progress Updates" />
                </Row>
            )}
            {updates.map((u) => (
                <Row key={u.id} widths={[15, 15, 70]}>
                    <ValueCell label="Date" value={u.createdAt} format="date" />
                    <ValueCell label="Status" value={progressUpdateStatus[u.status]} />
                    <ValueCell label="Progress Update" value={u.description} />
                </Row>
            ))}
            {spacer && (
                <Row>
                    <Cell height={4}></Cell>
                </Row>
            )}
        </>
    ) : null;
};

export default ProgressUpdates;
